import axios from "axios";
import { Types, actionTypes } from "../../context/action/action";
import store from "../../context/store/store";
import { ChatService } from "../chatService";
import { UrlConstants } from "../service/serviceConstant";
import { excelFormats, excelMimeFormats, imageFormat, imageFormatType, imageforpreview, mp3Formats, pdfFormats, pptFormats, pptMimeFormats, videoFormat, wordFormats, wordMimeFormats, zipFormats, zipMimeFormats } from "../utils";
import { chatSocketReducerStateModel } from "../../models/model";
import _ from "lodash";
import { config } from "../constant";

export class TPIService {
  public static async uploadAndDisplayFilesAlt(
    fileName: string,
    mimeType: string,
    url: string,
    token: string
  ) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      let fileNameMimeType = '';
      let ext = '';
      if(wordMimeFormats.includes(mimeType)){
        fileNameMimeType='application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        ext='.docx';
      } else if(pptMimeFormats.includes(mimeType)){
        fileNameMimeType='application/vnd.openxmlformats-officedocument.presentationml.presentation';
        ext='.pptx';
      } else if(excelMimeFormats.includes(mimeType)){
        fileNameMimeType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        ext='.xlsx';
      } else if(zipMimeFormats.includes(mimeType)){
        fileNameMimeType='application/zip';
        ext='.pdf';
      }else if(pdfFormats.includes(mimeType)){
        fileNameMimeType='application/pdf';
        ext='.pdf';
      } else {
        fileNameMimeType='application/pdf';
        ext='.pdf';
      }
      xhr.open("GET", url + "?mimeType="+fileNameMimeType, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      var blob ;
      xhr.onload = function() {
        blob = xhr.response;
        if(this.status===200){
          const file = new File([blob], fileName + ext, { type: fileNameMimeType });
          let filesinfo:any = {};
          filesinfo.fileName = file.name + ext;
          filesinfo.fileType = fileNameMimeType;
          filesinfo.filePath =  window.URL.createObjectURL(file);
          filesinfo.filesize =file.size;
          filesinfo.targetFile = file;
          ChatService.fileUpload(filesinfo);
        } else if(this.status===403) {

        }
        // fileUploadXMPP(file);
      };
      xhr.onerror = function() {
        console.log("** An error occurred during the transaction");
      };
      xhr.send();
    });
  }
  public static async uploadAndDisplayFiles(
    fileName: string,
    mimeType: string,
    url: string,
    token: string,
    fileId:string,
    googoleDriveUrl:string
  ) {
    const {filesAttach}:chatSocketReducerStateModel = store.getState().chatSocketReducerState;
    const self =this;
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      var blob ;
      xhr.onload = function() {
        blob = xhr.response;
        // if(this.status===200){
          const file = new File([blob], fileName, { type: mimeType });
          let filesinfo:any = {};
          filesinfo.fileName = file.name;
          filesinfo.fileType = file.type;
          filesinfo.filePath =  googoleDriveUrl;
          filesinfo.filesize =file.size;
          filesinfo.targetFile = file;
          filesinfo.txt = "";
          filesinfo.messageType = "FILE";
          filesinfo.isCloudfiles = true;
          console.log("filesinfo-------",filesinfo);
          const fileArray=  [...filesAttach, filesinfo]
          store.dispatch({
            type: actionTypes.FILE_ATTACHMENTS,
            payload:{
              filesAttach:fileArray
            }
          });
          // ChatService.fileUpload(filesinfo);
        // } else if(this.status===403) {
        //   self.uploadAndDisplayFilesAlt(fileName,mimeType,
        //     "https://www.googleapis.com/drive/v3/files/"+fileId+"/export",token);
        // }
        // fileUploadXMPP(file);
      };
      xhr.onerror = function() {
        console.log("** An error occurred during the transaction");
      };
      xhr.send();
    });
  };

  public static async downloadOneDriveFile(fileName: string,
    mimeType: string,
    url: string,
    token: string){
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
       
      var blob ;
      xhr.onload = function() {
        blob = xhr.response;
        const file = new File([blob], fileName, { type: mimeType });
    
        let filesinfo:any = {};
        filesinfo.fileName = file.name;
        filesinfo.fileType = mimeType;
        filesinfo.filePath =  window.URL.createObjectURL(file);
        filesinfo.filesize =file.size;
        filesinfo.targetFile = file;
        ChatService.fileUpload(filesinfo);
      };
      xhr.send();
    });
  }
  public static async fetchDropBoxTemporaryURL(
    token: string,
    mimeType: string,
    datav: string,
    filename: string,
    dropbox:string
  ){
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    };
    let self:any=this;
    const reqobject ={
      path: datav,
      drobox: dropbox
    };

    return axios
      .post("https://tpicb.worktual.co.uk/cb/cloudstorage/dropbox/filedownload", reqobject, config)
      .then((res) => {
        self?.displayFileAfterUpload(filename, mimeType, res.data.link, token);
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  public static async displayFileAfterUpload(
    fileName: string,
    mimeType: string,
    url: string,
    token: string
  ) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
     
      var blob ;
      xhr.onload = function() {
        blob = xhr.response;
        const file = new File([blob], fileName, { type: mimeType });
  
        let filesinfo:any = {};
        filesinfo.fileName = file.name;
        filesinfo.fileType = mimeType;
        filesinfo.filePath =  window.URL.createObjectURL(file);
        filesinfo.filesize =file.size;
        filesinfo.targetFile = file;
        ChatService.fileUpload(filesinfo);
      };
      xhr.send();
    });
  };

  public static async getDropboxToken(requestOptions:any){
    var axios = require('axios');
    axios(requestOptions)
      .then(function(response: any) {
        return response.data;
      })
      .catch(function(error: any) {
        console.log("API Error!!!");
      });
  }
  public static async storeToken(token:string){
    var axios = require('axios');
    var data = JSON.stringify({
      "token": token
    });
    const getToken = localStorage.getItem('one-drive') || null;
    if (getToken) {
      const parsedToken = JSON.parse(getToken);
      if (parsedToken.access_token) {
        var config = {
          method: 'post',
          url: UrlConstants.tpiCBAPI("cloudstorage/onedrive/storetoken"),
          headers: {
            'Authorization': 'Bearer ' + parsedToken.access_token,
            'Content-Type': 'application/json'
          },
          data: data
        };
  
        axios(config)
          .then(function(response: any) {
            return response.data;
          })
          .catch(function(error: any) {
            console.log("API Error!!!");
          });
      }
    }
  };



  public static async getClientsCloud(client:string){
    var axios = require('axios');
    const getToken = localStorage.getItem(client) || null;
    if (getToken) {
      const parsedToken = JSON.parse(getToken);
      if (parsedToken.access_token) {
        var config = {
          method: 'post',
          url:UrlConstants.tpiCBAPI("cloudstorage/dropbox/getclient"),
          headers: {
            'Authorization': 'Bearer ' + parsedToken.access_token,
            'Content-Type': 'application/json'
          }
        };
  
        return axios(config)
          .then(function(response: any) {
            return response.data;
          })
          .catch(function(error: any) {
            console.log("API Error!!!");
          });
      }
    }
  };
  public static async fetchDropBoxUserFiles(token: string, id: any = "",data:any) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    };
    // const datav = {
    //   path: id,
    //   recursive: false,
    //   include_media_info: false,
    //   include_deleted: false,
    //   include_has_explicit_shared_members: false,
    //   include_mounted_folders: true,
    //   include_non_downloadable_files: true
    // };
  
    return axios
      .post("https://tpicb.worktual.co.uk/cb/cloudstorage/dropbox/listfolder",data,config)
      .then((res) => {
        console.log("res---->",res);
        store.dispatch({
          type: Types.GET_DROPBOX_FILES,
          payloads: res.data.entries
        });
      })
      .catch((err) => {
        console.log("user files  eroror", err.response);
        // localStorage.removeItem('drop_box');
  
      });
  };
  public static async commonBridgeAuth(client:any) {
    console.log("client-----",client)
    let { userdetails } = store.getState().loginReducer;
    const userData = {company:userdetails.company_id,client:client,username:userdetails.Email};
    const clients:any = localStorage.getItem(client);
    const storageType:any = JSON.parse(clients);
    if(!storageType){
      return axios
        .post("https://tpicb.worktual.co.uk/cb/thirdparty",userData)
        .then((res) => {
  
          console.log("res", res);
          if(res.data.statusCode===200){
            localStorage.setItem(client,JSON.stringify(res.data));
          } else {
            localStorage.removeItem(client);
          }
          return res.data;
        })
        .catch((err) => {
          localStorage.removeItem(client);
        });
    } else {
      const config = {
        headers: { Authorization: `Bearer ${storageType["access_token"]}` }
      };
      return axios
        .get("https://tpicb.worktual.co.uk/cb",config)
        .then((response:any) => {
          const responseData = response.data;
          if(responseData?.statusCode===401){
            const refereshToken = storageType["refresh_token"];
            return axios
              .post("https://tpicb.worktual.co.uk/cb/refreshtoken",{token:refereshToken})
              .then((restoken) => {
                storageType["access_token"] = restoken.data.access_token;
                localStorage.setItem(client,JSON.stringify(storageType));
                return restoken.data;
              }).catch((err) => {
                console.log(err);
              });
          }
          return response.data;
        }).catch((err) => {
          console.log("ERR TPI", err);
          localStorage.removeItem(client);
          return "";
        });
    }
    
  };


public static async boxFileUpload(selectedFiles:any) {
  console.log("box file upload-------------")
  selectedFiles.forEach((elem:any)=> {
    return new Promise((resolve, reject) => {
      // var xhr = new XMLHttpRequest();
      let fileNameMimeType = '';
      let fileImageType = elem.name.split('.').pop();
      let fileUrl = "https://www.googleapis.com/drive/v3/files/" +elem.id +"?alt=media"

      if(wordFormats.includes(elem.extension)) {
        fileNameMimeType='application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      } else if(pptFormats.includes(elem.extension)) {
        fileNameMimeType='application/vnd.openxmlformats-officedocument.presentationml.presentation';
      } else if(excelFormats.includes(elem.extension)) {
        fileNameMimeType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }else if(pdfFormats.includes(elem.extension)) {
        fileNameMimeType='application/pdf';
      } else if(imageFormat.includes(elem.extension)) {
        fileNameMimeType = `image/${elem.extension}`
      }
      else if(videoFormat.includes(elem.extension)) {
        fileNameMimeType = `video/${elem.extension}`
      }
      else if(mp3Formats.includes(elem.extension)) {
        fileNameMimeType = `audio/${elem.extension}`
      }
      else if(elem.extension === 'exe') {
        fileNameMimeType = 'application/x-msdownload'
      }
      else if(zipFormats.includes(elem.extension)) {
        fileNameMimeType='application/zip';
      }
     
      let filesinfo:any = {};
      filesinfo.fileName = elem.name;
      filesinfo.fileType = fileNameMimeType;
      filesinfo.filePath =  elem.url;
      filesinfo.filesize = elem.size;
      filesinfo.isCloudfiles = true;
      filesinfo.targetFile = {...filesinfo};
      ChatService.fileUpload(filesinfo);
    });
  })

   
}

public static async getPrivatAppList(payload:any) {
  
    return await axios.post(`${config().TPI_PRIVATE_APP_URL}/appList`, payload,'').then((resp:any)=>{
      return resp.data;
    }).catch((err:any)=>{
        return false;
    })
}

public static async createEditPrivateApp(payload:any) {
  
  return await axios.post(`${config().TPI_PRIVATE_APP_URL}/private/connect`, payload).then((resp:any)=>{
    return resp.data;
  }).catch((err:any)=>{
      return false;
  })
  
}

public static async getUcaasScopes() {

  return await axios.get(`${config().TPI_PRIVATE_APP_URL}/scopes?type=ucaas`).then((resp:any)=>{
    return resp.data;
  }).catch((err:any)=>{
    return false;
  })
}

public static async deletePrivateApp(endpoint : any){
  
  return await axios.delete(`${config().TPI_PRIVATE_APP_URL}/${endpoint}`).then((resp : any) => {
    return resp.data;
  }).catch((err : any) => {
    return false;
  })
}

public static async privateAppDetails(appId : any) {

  return await axios.get(`${config().TPI_PRIVATE_APP_URL}/appDetail/${appId}`).then((resp : any) => {
    return resp.data;
  }).catch((err : any) => {
    return false;
  })
}

}